import { useState } from 'preact/hooks';
import { useLocation } from 'preact-iso';
import { api } from '../../lib/api.js';
import { useApi } from '../../hooks/useApi.js';
import { Button } from '../../components/Button.jsx';

const INK = '#F5EEDC';

export const InkDensityComparisonsPage = () => {
  const { route } = useLocation();
  const { data: comparisons, refetch } = useApi('/ink-density/comparisons');
  const [busy, setBusy] = useState(false);

  const createNew = async () => {
    if (busy) return;
    setBusy(true);
    try {
      const c = await api.post('/ink-density/comparisons', { name: 'New comparison', notes: null, readingIds: [] });
      route(`/ink-density/comparisons/${c.id}`);
    } finally { setBusy(false); }
  };

  return (
    <div>
      <nav class="mb-2 text-[11px] text-text-tertiary">
        <a href="/ink-density" class="text-text-tertiary hover:text-text-primary">Ink density</a> · Comparisons
      </nav>

      <section class="mb-5 flex items-start justify-between gap-4">
        <div>
          <div class="mb-1.5 flex items-center gap-2">
            <span class="block h-2.5 w-2.5 rounded-full" style={{ background: INK, border: '1px solid rgba(245,238,220,0.4)' }} />
            <span class="text-[11px] font-semibold uppercase tracking-eyebrow" style={{ color: INK }}>Comparisons</span>
          </div>
          <h1 class="m-0 mb-1.5 text-[30px] leading-[1.18] tracking-tight text-text-primary">Saved comparisons</h1>
          <p class="m-0 text-sm text-text-secondary">Named report mergers — pick multiple readings to compare side-by-side.</p>
        </div>
        <Button variant="primary" onClick={createNew} disabled={busy}>+ New comparison</Button>
      </section>

      {!comparisons && <p class="text-sm text-text-tertiary">Loading…</p>}
      {comparisons && comparisons.length === 0 && (
        <div class="surface-card p-6 text-center">
          <p class="m-0 font-serif text-lg font-medium text-text-primary">No comparisons yet.</p>
          <p class="m-0 mt-1 text-sm text-text-secondary">Create one to merge multiple readings into a side-by-side report.</p>
        </div>
      )}
      {comparisons && comparisons.length > 0 && (
        <div class="space-y-1.5">
          {comparisons.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => route(`/ink-density/comparisons/${c.id}`)}
              class="relative block w-full overflow-hidden rounded-md border border-border-subtle bg-bg-card p-3 text-left hover:border-border-strong"
            >
              <span class="pointer-events-none absolute inset-y-0 left-0 w-[3px]" style={{ background: INK }} aria-hidden="true" />
              <div class="flex items-baseline justify-between gap-3">
                <div>
                  <p class="m-0 font-serif text-[15px] text-text-primary">{c.name}</p>
                  {c.notes && <p class="m-0 mt-0.5 text-[12px] text-text-secondary">{c.notes}</p>}
                </div>
                <span class="text-[11px] text-text-tertiary">{c.readingCount} reading{c.readingCount === 1 ? '' : 's'}</span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
